<template>
  <v-dialog v-model="value" persistent max-width="400">
    <slot slot="activator" name="activator"></slot>
    <v-card>
      <v-toolbar flat>
        Новое изображение профиля
        <v-spacer></v-spacer>
        <v-btn flat icon @click.native="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card class="my-3" flat>
          <v-flex xs12 dark text-xs-center>
            <h3>
              <label v-show="!url"
              class="text-xs-center btn primary--text btn--block"
              style="cursor: pointer" for="userpicFileInput"
              >Выбрать файл</label>
            </h3>
            <div ref="croppie" :hidden="!url"></div>
          </v-flex>
          <input @change="onFileChange" ref="userpicFileInput" id="userpicFileInput" hidden type="file" accept="url/*"/>
        </v-card>
        <v-card color="amber lighten-3" light flat class="mt-4">
          <v-card-text>
            <i>Внимание! Изменения будут приняты лишь после проверки фото. Это может занять некоторое время.</i>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="cancel">отмена</v-btn>
        <v-btn color="primary" flat @click.native="done" :disabled="!url">готово</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const Croppie = require('croppie')
// events: @done @cancel
export default {
  name: 'userpic-crop',
  data: () => ({
    dialog: false,
    url: null,
    croppieInst: null
  }),
  props: ['value'],
  computed: {
    croppie () {
      return this.croppieInst
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.$refs.userpicFileInput.value = ''
      this.url = null
    },
    done () {
      this.$emit('done', { url: this.url })
      this.close()
    },
    cancel () {
      this.$emit('cancel')
      this.close()
    },
    onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    createImage (file) {
      const vm = this
      /*
      while (vm.$refs.croppie.firstChild) {
        console.log(vm.$refs.croppie.firstChild)
        vm.$refs.croppie.removeChild(vm.$refs.croppie.firstChild)
      }
      */
      vm.croppieInst = vm.croppieInst || new Croppie(vm.$refs.croppie, {
        viewport: { width: 220, height: 220 },
        boundary: { width: 220, height: 220 },
        showZoomer: false,
        enableOrientation: true
      })
      const reader = new FileReader()
      reader.onload = (e) => {
        vm.url = e.target.result
        vm.croppie.bind({
          url: vm.url
        })
      }
      reader.readAsDataURL(file)
    }
  },
  watch: {
    dialog (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.dialog = val
    }
  }
}
</script>

<style lang="css">
</style>
